const getBarIndexAtX = (x: number, plotLeft: number, plotRight: number, barCount: number): number | null => {
  const plotWidth = plotRight - plotLeft;
  if (barCount === 0 || plotWidth <= 0 || x < plotLeft || x >= plotRight) {
    return null;
  }
  return Math.floor(((x - plotLeft) / plotWidth) * barCount);
};

export { getBarIndexAtX };
